// extracted by mini-css-extract-plugin
module.exports = {"main":"main-15nEpA5f","main_middle":"main_middle-53vRsBLf","main_right":"main_right-34HVxxow","ad1":"ad1-27FmNa1V"};